module.exports = "/static/assets/62cfab30281b265d9e64dc417c9e9b79.png";